import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { InstallationStocksConfiguration } from "@/model/data/security/InstallationStocksConfiguration";
import { Denomination } from "@/model/data/Denomination";

export class FetchInstallationsRollsConfigurationResData extends ApiGenericResponse {
    installationsList: InstallationStocksConfiguration[];
    totalInstallationsCount: number = 0;
    allDenominations: Array<Denomination>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsList) {
            this.installationsList = new Array();
            obj.InstallationsList.forEach((element) => {
                let installationSecConf = new InstallationStocksConfiguration();
                installationSecConf.parse(element);
                this.installationsList.push(installationSecConf);
            });
        }
        if (obj.TotalInstallationsCount != null && obj.TotalInstallationsCount != undefined) this.totalInstallationsCount = obj.TotalInstallationsCount;
    }
}
